import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface PopOverState {
  isOpen: boolean;
}

export interface PopOverAction {
  setIsOpen: (isOpen: boolean) => void;
}
/**
 * Store to maintain signal's popover open/closed
 */
const use = create<PopOverState & PopOverAction>()(
  devtools(
    immer((set) => ({
      isOpen: false,
      setIsOpen: (isOpen: boolean) =>
        set(
          (state) => {
            state.isOpen = isOpen;
          },
          false,
          { type: 'SET_SIGNAL_POPOVER_STATE' },
        ),
    })),
    {
      store: 'Signal',
    },
  ),
);

export { use };
